
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LoadingOverlay extends Vue {
  // PROPS DEFINITIONS
  @Prop({ required: false, default: "Caricamento..." })
  private loadingOverlayText: string;
  @Prop({ required: false, default: false })
  private loadingOverlayOpen: boolean;
  // METHODS --- CLOSE
  public closeLoadingOverlay(): void {
    this.$emit("update:loadingOverlayOpen", false);
  }
}
